export interface IImpersonator {
  id: number;
  email: string;
}

/**
 * The backend does not expose the impersonation state on /me - it only puts the
 * impersonating admin into the JWT payload. Decoding the token locally is what
 * keeps the banner correct after a page refresh.
 */
const decodeJwtPayload = (token: string): any | null => {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "=",
    );
    const json = decodeURIComponent(
      atob(padded)
        .split("")
        .map((char) => "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );

    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};

export const getImpersonator = (
  token?: string | null,
): IImpersonator | null => {
  const rawToken = token ?? localStorage.getItem("token");
  if (!rawToken) return null;

  const payload = decodeJwtPayload(rawToken);
  if (!payload?.impersonatorId) return null;

  return {
    id: payload.impersonatorId,
    email: payload.impersonatorEmail ?? "",
  };
};

/**
 * Swapping the session mid-flight would leave the previous user's data cached in
 * component state, so both directions reboot the app with the new token.
 */
export const applyImpersonationToken = (token: string, redirectTo: string) => {
  localStorage.setItem("token", token);
  window.location.href = redirectTo;
};
